import { render, staticRenderFns } from "./managerDashboard.vue?vue&type=template&id=6b53c17c&scoped=true"
import script from "./managerDashboard.vue?vue&type=script&lang=js"
export * from "./managerDashboard.vue?vue&type=script&lang=js"
import style0 from "./managerDashboard.vue?vue&type=style&index=0&id=6b53c17c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b53c17c",
  null
  
)

export default component.exports